<template>
  <el-input
    v-model="inputVal"
    ref="token"
    :placeholder="$t('Integrations_Field_Token')"
  >
    <template slot="append" v-if="!readonly">
      <el-dropdown trigger="click">
        <el-button icon="el-icon-more" />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="inputVal !== ''" @click.native="copyToken">
            <i class="el-icon-copy-document" />
            {{ $t('Integrations_Message_CopyToClipboard') }}
          </el-dropdown-item>

          <el-dropdown-item v-if="inputVal === ''" @click.native="generate">
            <i class="el-icon-refresh" />
            {{ $t('Integrations_Message_GenerateToken') }}
          </el-dropdown-item>

          <el-dropdown-item v-else @click.native="revoke">
            <i class="el-icon-delete" />
            {{ $t('Integrations_Message_RevokeToken') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </el-input>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'IntegrationTokenInput',

  props: ['value'],

  data() {
    return {}
  },

  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

    revokeTokenEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `integrations/revoke-token`,
        params: {
          id: this.$route.query.id
        }
      })
    },

    generateTokenEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `integrations/generate-token`,
        params: {
          id: this.$route.query.id
        }
      })
    },

    readonly() {
      return !this.$can('manageProjectTechnical')
    }
  },

  methods: {
    generate() {
      this.confirmActionToken('generate', this.generateTokenEndpoint)
    },
    revoke() {
      this.confirmActionToken('revoke', this.revokeTokenEndpoint)
    },
    copyToken() {
      this.$refs.token.$refs.input.select()
      document.execCommand('copy')
      this.$message({
        message: this.$t('Integrations_Message_TokenCopied'),
        type: 'success'
      })
    },

    confirmActionToken(action, endpoint) {
      this.$msgbox({
        title:
          action === 'generate'
            ? this.$t('Integrations_DialogGenerateToken_Title')
            : this.$t('Integrations_DialogRevokeToken_Title'),
        message:
          action === 'generate'
            ? this.$t('Integrations_DialogGenerateToken_Prompt')
            : this.$t('Integrations_DialogRevokeToken_Prompt'),
        showCancelButton: true,
        confirmButtonText: this.$t('Integrations_Button_Confirm'),
        cancelButtonText: this.$t('Integrations_Button_Cancel'),
        center: true
      }).then(() => {
        this.loading = true
        RestApi(endpoint)
          .then(({ data }) => {
            if (action === 'revoke') {
              this.inputVal = ''
            } else if (action === 'generate') {
              this.inputVal = data
            }

            this.$message({
              message:
                action === 'generate'
                  ? this.$t('Integrations_Message_GenerateTokenSuccess')
                  : this.$t('Integrations_Message_RevokeTokenSuccess'),
              type: 'success'
            })

            this.loading = false
          })
          .catch(error => {
            this.$message({
              message: error.message,
              type: 'error'
            })
            this.loading = false
          })
      })
    }
  }
}
</script>
<style scoped>
>>> .el-button .el-icon-more {
  transform: rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/components/IntegrationTokenInput.vue